var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeRepyouLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 128,
    viewBox: "0 0 201 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.49219,
    y: 4,
    width: 191.861,
    height: 120,
    rx: 6,
    fill: "#F9FBFF",
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.678 110.501L130.677 97.9259L65.4696 97.8889C58.2957 97.8889 52.4561 93.009 52.4561 87.0087V28.8802C52.4561 22.881 58.2945 18 65.4709 18H134.662C141.838 18 147.678 22.881 147.678 28.8802V110.501ZM122.944 86.4301L135.796 96.3585L142.817 101.524V28.8802C142.817 25.1123 139.158 22.0464 134.662 22.0464H65.4709C60.9742 22.0464 57.3156 25.1123 57.3156 28.8802V87.0087C57.3156 90.7766 60.9742 93.8425 65.4709 93.8425L125.425 93.8764L119.633 89.3942L122.944 86.4301Z",
    fill: "#0F2F66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4423 51.619C89.9046 51.619 91.9007 49.1939 91.9007 46.2025C91.9007 43.2111 89.9046 40.7861 87.4423 40.7861C84.98 40.7861 82.9839 43.2111 82.9839 46.2025C82.9839 49.1939 84.98 51.619 87.4423 51.619Z",
    fill: "#0F2F66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.684 51.619C115.146 51.619 117.142 49.1939 117.142 46.2025C117.142 43.2111 115.146 40.7861 112.684 40.7861C110.222 40.7861 108.226 43.2111 108.226 46.2025C108.226 49.1939 110.222 51.619 112.684 51.619Z",
    fill: "#0F2F66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.067 80.0486C87.7361 80.0486 77.211 72.372 75.5853 62.1938L75.2188 59.9039H124.913L124.549 62.1949C122.923 72.3741 112.398 80.0486 100.067 80.0486ZM80.9695 63.9514C83.3407 70.9609 91.1108 76.0022 100.067 76.0022C109.022 76.0022 116.792 70.9609 119.165 63.9514H80.9695Z",
    fill: "#0F2F66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeRepyouLogo);
export default __webpack_public_path__ + "static/media/we-repyou-logo.258897de755113dc5b1b569d3359c21f.svg";
export { ForwardRef as ReactComponent };